const KnowledgeBaseIcon = () => {
    return (
        <svg
            id="Group_7901"
            data-name="Group 7901"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
        >
            <g id="Group_7900" data-name="Group 7900">
                <circle
                    id="Ellipse_54"
                    data-name="Ellipse 54"
                    cx="9.412"
                    cy="9.412"
                    r="9.412"
                    transform="translate(0.588 0.588)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_3371"
                    data-name="Path 3371"
                    d="M4.067,11.416l3.62-9.2,3.619,9.2m-7.239,0,3.62.941,3.619-.941m-7.239,0,3.62,3.837,3.619-3.837"
                    transform="translate(2.313 1.263)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.75"
                />
            </g>
        </svg>
    );
};

export default KnowledgeBaseIcon;
